import {useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import {useRouter} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'

import {ROUTES} from '../../../../../config/index.js'

const UserCloseSessionModal = ({handleModal}) => {
  const {domain, i18n} = useContext(Context)
  const router = useRouter()
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const imageUrl = `${URL_STATICS_IMAGES}pictograms/Logout.svg`

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => handleModal(false)}
    >
      <div className="mt-UserProfileComplete-modalContainer">
        <img
          className="mt-UserProfileComplete-modalImage"
          src={imageUrl}
          height={72}
          width={86}
          alt={i18n.t('COMMON.LOG_OUT')}
        />
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  color: 'accent',
                  customCallBack: () => {
                    router.push(ROUTES.LOGOUT)
                  },
                  isDisabled: false,
                  text: i18n.t('COMMON.LOG_OUT')
                },
                cancelButton: {
                  customCallBack: () => {
                    handleModal(false)
                  },
                  isDisabled: false,
                  text: i18n.t('COMMON.CANCEL')
                }
              },
              children: (
                <div className="mt-UserProfileComplete-modalChildren">
                  {i18n.t('RESERVATION_C2B.USER_FORM.MODAL_CLOSE_SESSION_TEXT')}
                </div>
              ),
              title: i18n.t('RESERVATION_C2B.USER_FORM.MODAL_CLOSE_SESSION_TITLE')
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}

UserCloseSessionModal.displayName = 'UserCloseSessionModal'

UserCloseSessionModal.propTypes = {
  handleModal: PropTypes.func
}

export default UserCloseSessionModal
